import MinerInfo from './MinerInfo';

export default MinerInfo;
